import { NonRelevantCell } from 'components/common-form/builder/form/node/field/NonRelevantField/NonRelevantCell';
import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';

export const NonRelevantField: FC<ProductNodeBuilderProps> = () => {
  return <NonRelevantCell />;
};

NonRelevantField.displayName = 'NonRelevantField';
